/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to set a Override default Menu for Focus logic.
 * <br><br>
 * @module MW/toolstrip/mixins/property/MenuMixin
 *
 * @copyright Copyright 2016-2019 The MathWorks, Inc.
 */


define([
    "dojo/_base/declare",
    "dijit/focus",
    "MW/uiframework/FocusManager"

], function (declare, focusUtil, FocusManager) {


    return declare(null, {

        postCreate: function () {
            this.inherited(arguments);
            this.set("menuOrientation", "below");
        },

        //override closemenu to restoreFocus in Toolstrip

        closeMenu: function (focus) {
            if(!this.domNode.classList.contains("mwPopupMenuItem")) {
                if(FocusManager.isAvailable()) {
                    // If either undefined or false, will emit "restorefocus"
                    if (!this.get("preventRestoreFocus")) {
                        this.emit("restorefocus");
                    }
                    //Calling only closing popup as focus manager takes care of focus
                    this._handleClosingPopup(focus);

                    // g2146269: Set aria-expanded value on the focusNode
                    this._setAriaExpanded();
                } else {
                    this.inherited(arguments);
                }
            }
        }
    });
});
